import { render, staticRenderFns } from "./PrivacyRules.vue?vue&type=template&id=ef1ae21c&scoped=true"
import script from "./PrivacyRules.vue?vue&type=script&lang=js"
export * from "./PrivacyRules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@2.0.1_webpack@4.47.0__css-loader@0.28.11_lodash@4.17.23_vue-t_lre32xywqxiddeo252btsfuiei/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef1ae21c",
  null
  
)

export default component.exports